import { getUserLocation as fetchUserLocation } from '../api/geolocation';

export const getCachedUserLocation = async () => {
  const cached = localStorage.getItem('userLocation');
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch {
      // fallback to fetch if parsing fails
    }
  }
  const location = await fetchUserLocation();
  if (location) {
    localStorage.setItem('userLocation', JSON.stringify(location));
  }
  return location;
};
